import { OrganizationType } from "../../common/constants";
import { useAuth } from "../../contexts/AuthContext";
import { useRequest } from "../useRequest";
import api from "../../utils/api";
import type { UseCreditBalanceResult } from "./types";

export const useCreditBalance = (): UseCreditBalanceResult => {
  const { user } = useAuth();

  const isQuantitySurveyor =
    user?.organizationType === OrganizationType.QUANTITY_SURVEYOR;

  const { data: creditBalance, isLoading } = useRequest(
    async () => api.getCreditBalance(),
    { manual: !isQuantitySurveyor, defaultParams: [] as [] },
  );

  return { creditBalance, isLoading, isQuantitySurveyor };
};
